import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IFlatNode, INodeBase} from '@Common/widgets/general/tree-extended/node/node.model';
import {CategoryModel, CategoryTreeNodeDump} from 'app/archivage/common/services/category/category.model';
import {SubSink} from '@Common/core/utils/subsink';
import {CategoryService} from 'app/archivage/common/services/category/category.service';
import {finalize} from 'rxjs/operators';


@Component({
  selector: 'app-category-select',
  templateUrl: './category-select.component.html',
  styleUrls: ['./category-select.component.scss']
})
export class CategorySelectComponent implements OnInit, OnDestroy {
  static incomingData: CategorySelectData;
  subSink = new SubSink();
  categoryTree: CategoryTreeNodeDump[];
  catId: number;
  catName = '';
  entity: number;
  loading = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CategorySelectData,
    public dialogRef: MatDialogRef<CategorySelectComponent>,
    private categorySvc: CategoryService,
  ) {
    if (data) {
      CategorySelectComponent.incomingData = data;
      this.entity = data?.entity;
    }
  }
  ngOnInit(): void {
    this.loading = true;
    this.subSink.sink = this.categorySvc
      .listDumpStored(true, this.entity ? [this.entity] : null)
      .pipe(finalize(() => this.loading = false))
      .subscribe(_data => {
        let _categories = _data;
        if (this.data.excludeEmptyDua) {
          _categories = this._excludeEmptyDua(_data);
        }
        this.categoryTree = _categories;
      });
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

  getNodeName(node: IFlatNode<CategoryTreeNodeDump>) {
    // incomingData devient static, car perte du this quand la callback est appelée
    if (CategorySelectComponent.incomingData?.displayDuasCount) { return `${node?.item?.data?.name} (${node?.item?.data?.duas_count})`; }
    else { return node?.item?.data?.name; }
  }

  selectNode($event: IFlatNode<CategoryTreeNodeDump>) {
    this.catName = $event.item.data.name;
    this.catId = $event.item.id;
  }

  close() {
    this.dialogRef.close(false);
  }

  save() {
    const category: CategoryModel = <CategoryModel>{
      id: this.catId,
      name: this.catName
    };
    this.dialogRef.close(category);
  }
  private _excludeEmptyDua(arr: INodeBase<CategoryTreeNodeDump>[]) {
    return arr
      .map((elt) => {
        if (!this._hasChildrenAndIsArray(elt) && elt.data.duas_count !== 0) {
          return elt as CategoryTreeNodeDump;
        }
        if (this._hasChildrenAndIsArray(elt)) {
          elt.children = this._excludeEmptyDua(elt.children);
        }
        if (elt.data.duas_count !== 0) {
          return elt as CategoryTreeNodeDump;
        }
      })
      .filter(_elt => _elt);
  }
  private _hasChildrenAndIsArray(elt: INodeBase<CategoryTreeNodeDump>) {
    return !!(elt.children || Array.isArray(elt.children));
  }
}

export interface CategorySelectData {
  displayDuasCount: boolean;
  excludeEmptyDua?: boolean;
  entity?: number;
}
